import React from 'react';
import { Box, TextField, Button, MenuItem, Link } from '@mui/material';
import BaseCodeSelectbox from '../selectbox/BaseCodeSelectbox';

export const PartnerListBox = ({ formik, link }) => {
  return (
    <div>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          justifyContent: 'flex-start',
          alignItems: 'center',
          my: 1,
        }}
      >
        <Box
          component="form"
          noValidate
          autoComplete="off"
          sx={{
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-end',
            alignItems: 'center',
            mr: 2,
          }}
          onSubmit={formik.handleSubmit}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-start',
              alignItems: 'center',
              '& > :not(style)': { m: 1, width: '25ch' },
            }}
          >
            <BaseCodeSelectbox
              formik={formik}
              label="거래처 종류"
              variant="standard"
              required={false}
              fullWidth
              filterObject={{
                blcCd: 'BASE',
                mlcCd: 'PARTNER',
                slcCd: 'PARTNER_TYP',
                useYn: 'Y',
              }}
              name="searchPartnerTyp"
              size="small"
            />
            <TextField
              variant="standard"
              required
              select
              id="searchKeyword"
              name="searchKeyword"
              label="검색키워드"
              value={formik.values.searchKeyword}
              onChange={formik.handleChange}
              error={
                formik.touched.searchKeyword &&
                Boolean(formik.errors.searchKeyword)
              }
              helperText={
                formik.touched.searchKeyword && formik.errors.searchKeyword
              }
            >
              <MenuItem value="partnerNm">회사명</MenuItem>
              <MenuItem value="regNumber">사업자번호</MenuItem>
              <MenuItem value="partnerPhone">연락처</MenuItem>
            </TextField>
            <TextField
              variant="standard"
              required
              id="searchWords"
              name="searchWords"
              label="검색어"
              onChange={formik.handleChange}
              error={
                formik.touched.searchWords && Boolean(formik.errors.searchWords)
              }
              helperText={
                formik.touched.searchWords && formik.errors.searchWords
              }
            />
          </Box>

          <Box>
            <Button
              type="submit"
              color="info"
              variant="contained"
              disabled={formik.isSubmitting}
            >
              검색
            </Button>
          </Box>
          {link && (
            <Box sx={{ mx: 2 }}>
              <Button
                component={Link}
                color="warning"
                variant="contained"
                target="_blank"
                rel="noopener noreferrer"
                href="/partnermng/add"
              >
                거래처 등록
              </Button>
            </Box>
          )}
        </Box>
      </Box>
    </div>
  );
};
